interface SetCookieTokenProps {
  key: string;
  token: string;
  maxAge?: number;
  isProdEnv?: boolean;
}

const setCookieToken = ({ key, token, maxAge = 30 * 86400, isProdEnv = false }: SetCookieTokenProps) => {
  if (isProdEnv) {
    return `${key}=${encodeURIComponent(token)}; Path=/; Max-Age=${maxAge}; SameSite=Lax; Secure`;
  }

  return `${key}=${encodeURIComponent(token)}; Path=/; Max-Age=${maxAge}; SameSite=Lax;`;
};

const removeCookieToken = ({ key, isProdEnv = false }: { key: string; isProdEnv?: boolean }) => {
  if (isProdEnv) {
    return `${key}=; Path=/; Max-Age=0; SameSite=Lax; Secure; HttpOnly`;
  }

  return `${key}=; Path=/; Max-Age=0; SameSite=Lax; HttpOnly`;
};

export { removeCookieToken, setCookieToken };
